import { createContext, useContext, useState, type ReactNode } from "react";

interface SidebarContextType {
    isMobileOpen: boolean;
    setIsMobileOpen: (open: boolean) => void;
    toggleMobileSidebar: () => void;
    isDesktopCollapsed: boolean;
    setIsDesktopCollapsed: (collapsed: boolean | ((prev: boolean) => boolean)) => void;
    toggleDesktopSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function SidebarProvider({ children }: { children: ReactNode }) {
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    
    // Simpan status collapse desktop di localStorage agar persisten
    const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(() => {
        try {
            const saved = localStorage.getItem("sidebar_collapsed");
            return saved === "true";
        } catch (e) {
            return false;
        }
    });

    const toggleMobileSidebar = () => {
        setIsMobileOpen((prev) => !prev);
    };

    const toggleDesktopSidebar = () => {
        setIsDesktopCollapsed((prev) => {
            const next = !prev;
            try {
                localStorage.setItem("sidebar_collapsed", String(next));
            } catch (e) {
                // Abaikan jika localStorage tidak tersedia
            }
            return next;
        });
    };

    return (
        <SidebarContext.Provider
            value={{
                isMobileOpen,
                setIsMobileOpen,
                toggleMobileSidebar,
                isDesktopCollapsed,
                setIsDesktopCollapsed,
                toggleDesktopSidebar,
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebarContext() {
    const context = useContext(SidebarContext);
    // Jika tidak di dalam provider (contohnya di StepLayout), balikkan default agar tidak error
    if (!context) {
        return {
            isMobileOpen: false,
            setIsMobileOpen: () => {},
            toggleMobileSidebar: () => {},
            isDesktopCollapsed: false,
            setIsDesktopCollapsed: () => {},
            toggleDesktopSidebar: () => {},
        };
    }
    return context;
}
